module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-tablet-es.da21265d.png";